import { useEffect } from 'react'

const SITE_NAME = 'Biosecurity Reporter'
const BASE_URL = 'https://bioreport.vaultappsolutions.com'

function setMetaTag(name: string, content: string) {
  let el = document.querySelector(`meta[name="${name}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute('name', name)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

/** Sets the document title, meta description, and canonical link for the current route —
 * this is a plain SPA with a single static index.html, so nothing does this by default and
 * every page was showing the same generic title/description regardless of route. `path` is
 * the route's own path (e.g. '/about'), used to build the canonical URL. */
export function usePageMeta(title: string, description: string, path: string) {
  useEffect(() => {
    document.title = title === SITE_NAME ? title : `${title} — ${SITE_NAME}`
    setMetaTag('description', description)

    let canonical = document.querySelector('link[rel="canonical"]')
    if (!canonical) {
      canonical = document.createElement('link')
      canonical.setAttribute('rel', 'canonical')
      document.head.appendChild(canonical)
    }
    canonical.setAttribute('href', `${BASE_URL}${path}`)
  }, [title, description, path])
}
